import { AxiosResponse } from 'axios';

export async function unwrapResponse<T>(
  input: Promise<AxiosResponse<T>>
): Promise<T> {
  return (await input).data;
}
